import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckIcon, MinusIcon, AlertTriangleIcon, ChevronDownIcon } from 'lucide-react';
interface ReasoningCardProps {
  title: string;
  verdict: string;
  status: 'positive' | 'neutral' | 'caution';
  explanation: string;
  defaultExpanded?: boolean;
}
export function ReasoningCard({
  title,
  verdict,
  status,
  explanation,
  defaultExpanded = false
}: ReasoningCardProps) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const statusConfig = {
    positive: {
      color: 'bg-green-500',
      icon: CheckIcon
    },
    neutral: {
      color: 'bg-yellow-500',
      icon: MinusIcon
    },
    caution: {
      color: 'bg-orange-500',
      icon: AlertTriangleIcon
    }
  };
  const {
    color,
    icon: StatusIcon
  } = statusConfig[status];
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="bg-zinc-900 rounded-lg border border-zinc-800 overflow-hidden" data-id="element-34">
      <button onClick={() => setIsExpanded(!isExpanded)} className="w-full px-6 py-4 flex items-center gap-4 hover:bg-zinc-800/50 transition-colors text-left" data-id="element-35">
        <div className={`w-8 h-8 rounded-full ${color} flex items-center justify-center flex-shrink-0`} data-id="element-36">
          <StatusIcon className="w-4 h-4 text-zinc-950" data-id="element-37" />
        </div>

        <div className="flex-1" data-id="element-38">
          <span className="text-zinc-200 font-medium" data-id="element-39">{title}</span>
          <span className="text-zinc-500 mx-2" data-id="element-40">·</span>
          <span className="text-zinc-400" data-id="element-41">{verdict}</span>
        </div>

        <ChevronDownIcon className={`w-5 h-5 text-zinc-500 transition-transform ${isExpanded ? 'rotate-180' : ''}`} data-id="element-42" />
      </button>

      <AnimatePresence initial={false} data-id="element-43">
        {isExpanded && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-44">
            <div className="px-6 pb-4 pl-[72px]" data-id="element-45">
              <p className="text-zinc-400 text-sm leading-relaxed" data-id="element-46">
                {explanation}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}